import { format } from 'date-fns'

export const sleep = (time: number) =>
    new Promise((resolve) => setTimeout(resolve, time))

export const formatDate = (
    date: number | string,
    formatting = 'dd MMM yyyy'
) => {
    return format(new Date(date), formatting)
}

export const passedSince = (date: string, amount: number): boolean => {
    const now = new Date().getTime()
    const targetTime = new Date(date).getTime() + amount
    return now > targetTime
}

export const asyncCallWithTimeout = async (
    asyncPromise: Promise<any>,
    timeLimit = 0
) => {
    let timeoutHandle: any

    const timeoutPromise = new Promise((_resolve, reject) => {
        timeoutHandle = setTimeout(
            () => reject(new Error('Async call timeout limit reached')),
            timeLimit
        )
    })

    return Promise.race([asyncPromise, timeoutPromise]).then((result) => {
        clearTimeout(timeoutHandle)
        return result
    })
}
